import React from "react";
import PageTitlePlaceholder from "../PageTitlePlaceholder";
import AboutDescriptionPlaceholder from "./AboutDescriptionPlaceholder";
function AboutPlaceholderUpper () {
  return (
    <div className="pb-2">
      <PageTitlePlaceholder />
      <AboutDescriptionPlaceholder/>
    </div>
  );
}

export default AboutPlaceholderUpper;